import type { AlertTestIdAttributes } from '@data/notification/types';
import { useVehicleAlertContent } from '@data/notification/vehicle';
import type { VehicleAlert } from '@data/notification/vehicle/types';
import { Box, Stack, Typography } from '@mui/material';
import isNullOrUndefined from '@utils/isNullOrUndefined';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  alert: VehicleAlert;
  testIdAttrs?: AlertTestIdAttributes;
};

const VehicleAlertContent: React.FC<Props> = ({
  alert,
  testIdAttrs,
}: Props) => {
  const { t } = useTranslation();
  const { title, message, linkButton } =
    useVehicleAlertContent(alert);

  if (isNullOrUndefined(alert.vehicle)) return null;

  return (
    <Box maxWidth={400}>
      <Typography variant="subtitle2" data-testid={testIdAttrs?.titleTestId}>
        {title}
      </Typography>
      <Typography variant="caption">{alert.notifiedAt}</Typography>
      {!alert.driveOptions ? (
        <Typography data-testid={testIdAttrs?.messageTestId}>
          {t('vehicle.name')}: {alert.vehicle.vehicle_name}
        </Typography>
      ) : (
        <Stack spacing={4} my={1} direction="row">
          <Typography data-testid={testIdAttrs?.messageTestId}>
            {t('vehicle.name')}: {alert.vehicle.vehicle_name}
          </Typography>
          <Typography>
            {t('notification.drive.device_name')}:{' '}
            {alert.driveOptions.deviceTag}
          </Typography>
        </Stack>
      )}
      {message}
      {linkButton}
    </Box>
  );
};

export default React.memo(VehicleAlertContent);
